/* src/app/builder-screen-beta/event-scripting/event-list.component.scss */
.event-list-container {
  padding: 8px 0;
}
.event-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.event-card {
  border: 1px solid #d9d9d9;
  transition: all 0.3s ease;
}
.event-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.event-card.event-disabled {
  opacity: 0.6;
  background-color: #fafafa;
}
.event-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.event-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.event-info nz-icon {
  font-size: 16px;
  color: #1890ff;
}
.event-info .event-type {
  font-weight: 500;
  color: #262626;
}
.event-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.event-card-body {
  margin-bottom: 12px;
}
.event-description {
  margin: 0 0 8px 0;
  color: #595959;
  font-size: 13px;
  line-height: 1.5;
}
.event-details {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.event-card-footer {
  display: flex;
  gap: 4px;
  border-top: 1px solid #f0f0f0;
  padding-top: 8px;
  margin-top: 8px;
}
/*# sourceMappingURL=event-list.component.css.map */
